'use strict';

module.exports = require('./Tooltip');


/*****************
 ** WEBPACK FOOTER
 ** ./~/_rc-tooltip@3.4.3@rc-tooltip/lib/index.js
 ** module id = 658
 ** module chunks = 0 1
 **/